import { render, staticRenderFns } from "./workMeasureResultAttach.vue?vue&type=template&id=116588b4"
import script from "./workMeasureResultAttach.vue?vue&type=script&lang=js"
export * from "./workMeasureResultAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116588b4')) {
      api.createRecord('116588b4', component.options)
    } else {
      api.reload('116588b4', component.options)
    }
    module.hot.accept("./workMeasureResultAttach.vue?vue&type=template&id=116588b4", function () {
      api.rerender('116588b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/workMeasureResultAttach.vue"
export default component.exports